import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-both",
  templateUrl: "./med-icon-arrow-both.component.html",
})
export class MedIconArrowBothComponent extends SvgMixinComponent {}
